module.exports = __webpack_public_path__ + "img/icon-gen-searchairtime.a4f99592.png";